import React from 'react';
import styled, { css } from 'styled-components';
import styleGenerator from '../../utils/styles/utils/styleGenerator';

type Props = {
  all?: number;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  vertical?: number;
  horizontal?: number;
  [key: string]: any;
};

const spec = [
  props => ({
    loop: ['all', 'top', 'right', 'bottom', 'left', 'horizontal', 'vertical'],
    key: [
      ['margin-top', 'margin-right', 'margin-bottom', 'margin-left'],
      ['margin-top'],
      ['margin-right'],
      ['margin-bottom'],
      ['margin-left'],
      ['margin-left', 'margin-right'],
      ['margin-top', 'margin-bottom']
    ],
    value: ({ loop }) => `${props[loop]}px`
  })
];

const MarginWrapper = styled.div<Props>`
  ${styleGenerator(spec)}
`;

const Margin: React.FC<Props> = ({
  all,
  top,
  right,
  bottom,
  left,
  vertical,
  horizontal,
  children,
  ...rest
}) => (
  <MarginWrapper
    all={all}
    top={top}
    right={right}
    bottom={bottom}
    left={left}
    vertical={vertical}
    horizontal={horizontal}
    {...rest}
  >
    {children}
  </MarginWrapper>
);

export default Margin;
